import { Flex, Text } from '@bitrise/bitkit';
import { TypeMetricUnit } from '@trace/types';
import React, { FunctionComponent } from 'react';

import getFormattedValue from '../../../utils/metric/getFormattedValue';
import { getChange } from '../OverviewComparison/getComparisonValues';
import ChangeBadge from '../../ChangeBadge/ChangeBadge';

type Props = {
  currValue: number | null;
  prevValue: number | null;
  unit: TypeMetricUnit;
};

const OverviewTooltipComparison: FunctionComponent<Props> = ({ currValue, prevValue, unit }) => {
  const change = getChange(currValue, prevValue);

  return (
    <Flex direction="vertical" alignChildrenHorizontal="middle" gap="x2">
      <Flex>
        <Text>{getFormattedValue(unit, currValue)}</Text>
      </Flex>

      {change !== null && (
        <Flex>
          <ChangeBadge backgroundColor="gray-8" change={change} textColor="white" />
        </Flex>
      )}
    </Flex>
  );
};

export default OverviewTooltipComparison;
